import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import _typeof from "D:\\xiangmu\\03.\u6821\u9605\u901A\\01.weixin\\reader-platform\\node_modules\\@babel\\runtime/helpers/esm/typeof";
import axios from 'axios';
import utils from './utils';
import { Toast } from 'vant';
import store from '../store.js';
import { GetToken } from '../api/login';
import { getUrlParams } from '../common/myFunc'; // axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

var $options;
var loadingInstance;
var language = store.state.language;
var text1, text2, text3;

if (language == 'cn') {
  text1 = '登录超时，请重新登录';
  text3 = '图书已借入，无法取消预约';
} else if (language == 'en') {
  text1 = 'Login timed out';
  text3 = 'The book has been borrowed, the appointment cannot be cancelled';
}

var baseURL;
var request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});
request.interceptors.request.use(function (config) {
  var parten = new RegExp('login');
  var isLoginPage = parten.test(location.href);
  var token = utils.getSession('token') ? utils.getSession('token') : '';
  var Code = utils.getSession('Code') || utils.getLocal('Code') ? utils.getSession('Code') || utils.getLocal('Code') : ''; //单位编码

  config.headers.Token = token;
  config.headers.Code = Code;
  config.headers.SourceName = 'webXyt';
  config.headers.WxID = process.env.VUE_APP_AppId;
  return config;
}, function (error) {
  if (window.Global.loading) {
    window.Global.loading.hide();
  }

  return Promise.reject(error);
});
request.interceptors.response.use(function (res) {
  if (!res.data.iserror) {
    if (window.Global.loading) {
      window.Global.loading.hide();
    }

    return Promise.resolve(res.data);
  } else {
    if (res.data.errorcode === 40002 || res.data.errorcode === 40003) {
      //token已超时和无效的token参数
      if (location.href.indexOf('/application') != -1) {
        //如果是application中的应用（设备展示大屏），直接获取token，不跳转到授权页面
        GetToken({
          Corpid: process.env.VUE_APP_Corpid,
          Secret: process.env.VUE_APP_Secret
        }).then(function (data) {
          if (!data.iserror) {
            utils.setSession('token', data.data.access_token);
          }
        });
      } else {
        Toast(text1);
        utils.removeSession('token');
        setTimeout(function () {
          location.href = '/authorization';
        }, 2000);
      }
    } else if (res.data.errorcode === 50004) {
      //用户未绑定
      //第一版：用户必须先绑定身份，才能进入首页
      //location.href = "/login"
      //第二版：用户未绑定身份时，也可进入首页浏览，点击具体应用再进行绑定账号的操作
      // location.href = '/home?isTourist=' + true + '&isBindTel=' + false;
      // location.href = '/home?isTourist=' + true;
      console.log(process.env.VUE_APP_HPUIAS);
      console.log(_typeof(process.env.VUE_APP_HPUIAS));
      var HPUIAS = process.env.VUE_APP_HPUIAS;

      if (HPUIAS == 'true') {
        console.log('黄浦区教育学院'); //跳转到黄浦区教育学院的统一身份认证平台

        location.href = 'http://39.101.209.199:11000/connect/authorize?client_id=HPQJYXYTSG.Wechat&redirect_uri=http%3A%2F%2Flibrary.shsyzn.com.cn%2Foauth&response_type=code&scope=openid%20profile%20email%20phone';
      } else {
        console.log('非黄浦区教育学院');
        var fullpath = utils.getSession('fullpath');

        if (fullpath) {
          //是从某个页面跳转进来的
          location.replace('/login');
        } else {
          location.replace('/home?isTourist=' + true + '&time=' + Date.parse(new Date()));
        }
      }
    } else if (res.data.errorcode === 60018) {
      Toast(text3);
      window.location.reload();
    } else if (res.data.errorcode === 71001) {
      var code = getUrlParams('Code');
      location.href = '/unauth?code=' + code;
    } else if (res.data.errorcode === 50010) {
      return Promise.reject(res.data);
    } else {
      Toast(res.data.errormsg);
    }

    if (window.Global.loading) {
      window.Global.loading.hide();
    }

    return Promise.reject(res.data);
  }
}, function (error) {
  if (window.Global.loading) {
    window.Global.loading.hide();
  }

  return Promise.reject(error);
});
var http = {
  post: function post(url, data, options) {
    var o = Object.assign({
      loading: true,
      error: true
    }, options);
    return request({
      url: url,
      data: data,
      method: 'post',
      $options: o
    });
  },
  get: function get(url, data) {
    return request({
      url: url,
      params: data,
      method: 'get'
    });
  }
};
export default http;